<template>
  <div>
    <div class="wrap" v-if="!showLoading">
      <div class="img-wrap">
        <img v-lazy="fxImg" />
      </div>
      <div class="tip">长按上方图片发送给好友</div>
    </div>
    <loading v-if="showLoading"></loading>
    <div class="btn-qr" @click="showSharePopup = true">
      <div class="qr-wrap">
        <i class="iconfont icon-erweima"></i>
      </div>
    </div>
    <fenxiao-share-popup
      v-show="showSharePopup"
      :shareUrl="shareUrl"
      :qrImg="qrImg"
      @closePopup="closePopup"
    ></fenxiao-share-popup>
  </div>
</template>
<script type="text/ecmascript-6">
import { getFenxiaoImg } from '@/api/fenxiao.js'
import Loading from '../base/loading/loading.vue'
import { RES_OK } from '@/api/config'
import FenxiaoSharePopup from './fenxiao-share-popup.vue'
import { wxShare } from '@/api/wx-share'
export default {
  data() {
    return {
      url: this.$route.params.url,
      courseId: this.$route.params.courseId,
      courseTitle: this.$route.params.courseTitle,
      showLoading: true,
      fxImg: '', // 分销图片
      qrImg: '', // 二维码图片
      showSharePopup: false, // 是否显示分享弹框,
      shareUrl: ''
    }
  },
  created() {
    console.log(this.url, this.courseId)
    this._getFenxiaoImg()
  },
  methods: {
    _getFenxiaoImg() {
      getFenxiaoImg(this.courseId, this.url).then(res => {
        this.showLoading = false
        let data = res.data
        if (data.code === RES_OK) {
          this.fxImg = data.data.img
          this.qrImg = data.data.qrcode
          this.shareUrl = data.data.url
          // 数据正确返回 配置这个页面的分享链接
          wxShare({
            link: this.shareUrl,
            title: this.courseTitle || 'golo维修课堂',
            desc: '我正在学习这个汽修课程，全是实战干货，现学现用，戳进来和我一起学吧！'
          }, {
            link: this.shareUrl,
            title: this.courseTitle || 'golo维修课堂',
            desc: '我正在学习这个汽修课程，全是实战干货，现学现用，戳进来和我一起学吧！'
          })
        }
      })
    },
    closePopup() {
      this.showSharePopup = false
    }
  },
  components: {
    Loading,
    FenxiaoSharePopup
  }
}
</script>
<style scoped lang="stylus" ref="stylesheet/stylus">
  @import "~common/stylus/variable"
  .wrap
    background #333
    min-height 100vh
  .tip
    position fixed
    left 0
    bottom 0
    width 100%
    background $color-theme
    line-height size(90)
    text-align center
    font-size size(34)
    color #fff
  .img-wrap
    padding size(30) size(30) size(90+30)
    img
      display block
      width 100%
  .btn-qr{
    position relative
    width: size(80)
    height: size(80)
    position fixed
    bottom size(170)
    right size(75)
    -webkit-border-radius: 50%
    -moz-border-radius: 50%
    border-radius: 50%
    background-color: #fff
    -webkit-box-shadow: $color-theme 0 0 size(20) size(6)
    -moz-box-shadow: $color-theme 0 0 size(20) size(6)
    box-shadow: $color-theme 0 0 size(20) size(6)
    .qr-wrap{
      position absolute
      top 50%
      left 50%
      -webkit-transform: translate(-50%, -50%)
      -moz-transform: translate(-50%, -50%)
      -ms-transform: translate(-50%, -50%)
      -o-transform: translate(-50%, -50%)
      transform: translate(-50%, -50%)
      color $color-theme
      i{
        font-size size(50)
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/fenxiao/fenxiao.vue